/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<defs><path pid="0" d="M530.577 565.192v-3.23h-3.154v3.23h3.154zm0 12.846v-9.615h-3.154v9.615h3.154zM529 554c2.923 0 5.628.73 8.115 2.192a15.165 15.165 0 015.693 5.693c1.461 2.487 2.192 5.192 2.192 8.115s-.73 5.628-2.192 8.115a15.165 15.165 0 01-5.693 5.693C534.628 585.269 531.923 586 529 586s-5.628-.73-8.115-2.192a15.451 15.451 0 01-5.693-5.731A15.665 15.665 0 01513 570c0-2.897.73-5.59 2.192-8.077 1.41-2.41 3.32-4.32 5.731-5.73A15.665 15.665 0 01529 554z" id="svgicon_info_a"/></defs><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_info_a" transform="translate(-513 -554)"/>'
  }
})
